/**
 * Status Bar Component
 * Shows project selector and status information
 */

import React from 'react';
import { useApp } from '../../store/AppContext';
import './StatusBar.css';

export function StatusBar() {
  const { state, setCurrentProject, openProjectModal } = useApp();

  const handleProjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const project = state.projects.find(p => p.id === e.target.value);
    setCurrentProject(project ?? null);
  };

  return (
    <footer className="statusbar">
      <div className="statusbar__left">
        <div className="statusbar__project">
          <label className="statusbar__label">Project:</label>
          <select
            className="statusbar__select"
            value={state.currentProject?.id ?? ''}
            onChange={handleProjectChange}
            disabled={state.projectsLoading}
          >
            {state.projects.length === 0 ? (
              <option value="">No projects</option>
            ) : (
              state.projects.map(project => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))
            )}
          </select>
        </div>

        <button
          className="statusbar__button"
          onClick={openProjectModal}
          title="New Project (Ctrl+N)"
        >
          <svg viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z" />
          </svg>
          New
        </button>
      </div>

      <div className="statusbar__right">
        <div className="statusbar__status">
          <span className="statusbar__status-dot" />
          <span className="statusbar__status-text">{state.statusMessage}</span>
        </div>
      </div>
    </footer>
  );
}
